import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSignedCounter = createSelector(
  [(store: RootState) => store.documentsSignerList.signedCounter],
  (data) => data || 0
);
